export interface Css {
  selettore: string;
  keyValue: KeyValueCss[];
}

interface KeyValueCss {
  attributo: string;
  valore: string;
}


export function patchCss(shadow: ShadowRoot, css: Css[]) {
  const sheet = new CSSStyleSheet();
  sheet.replaceSync(
    css
      .map((css) => {
        const rules = css.keyValue
          .map((kv) => `${kv.attributo}: ${kv.valore};`)
          .join('\n');
        return `${css.selettore}{
      \n ${rules};
       \n
       }`;
      })
      .join('\n\n'),
  );

  shadow.adoptedStyleSheets = [...shadow.adoptedStyleSheets, sheet];
}
